import React, { Component } from "react";
import styles from "./FeaturedVideo.module.scss";
import { Button } from "@mui/material";
 
const GetIframeVideo = (props) => (
  <iframe
    className={props.className}
    title={props.title}
    src={props.url}
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;"
    allowFullScreen
    {...props}
  />
);

class FeaturedVideo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      video: this.props.video || "",
    };
  }

  toggleInstructionCollapse = () => {
    this.setState({ showModal: !this.state.showModal });
  };

  render() {
    return (
      <div className={`${styles.contentContainer} ${this.props.className}`}>
          <Button
            onClick={this.toggleInstructionCollapse}
            to={"/"}
            className={styles.videoButton}
          >
            {this.props.children}
          </Button>
          {this.state.showModal && (
            <div
              className={styles.popupBG}
              onClick={this.toggleInstructionCollapse}
            >
              <GetIframeVideo
                url={this.state.video}
                loading="lazy"
                themePlay
                className={styles.videoFrame}
              />
            </div>
          )}
      </div>
    );
  }
}

export default FeaturedVideo;
